/**
 * Valid group identifiers used throughout the application
 */
export const GROUP_IDS = {
  TROOP_400B: "400B",
  TROOP_400G: "400G",
  CUBS: "cubscouts",
} as const;

/**
 * Array of all valid group IDs
 */
export const VALID_GROUP_IDS = Object.values(GROUP_IDS);

/**
 * Group ID type
 */
export type GroupId = (typeof GROUP_IDS)[keyof typeof GROUP_IDS];

/**
 * Type guard to check if a string is a valid group ID
 */
export function isValidGroupId(id: string): id is GroupId {
  return VALID_GROUP_IDS.includes(id as GroupId);
}
